module.exports = __webpack_public_path__ + "img/5.cd179ef8.jpg";